import { all, takeLatest } from 'redux-saga/effects';
import {
  GET_PAYMENTS,
  GET_PAYMENT_DEBITS,
  ONLINE_PAYMENT_INFO,
  UPSERT_PAYMENT,
} from '../../actions/payments';
import {
  getAllPaymentsSaga,
  getOnlinePaymentInfoSaga,
  getPaymentsDebitsSaga,
  upsertPaymentSaga,
} from './getPaymentsSaga';

function* paymentSagas() {
  yield all([
    yield takeLatest(UPSERT_PAYMENT.INITIATE, upsertPaymentSaga),
    yield takeLatest(GET_PAYMENTS.INITIATE, getAllPaymentsSaga),
    yield takeLatest(ONLINE_PAYMENT_INFO.INITIATE, getOnlinePaymentInfoSaga),
    yield takeLatest(GET_PAYMENT_DEBITS.INITIATE, getPaymentsDebitsSaga),
  ]);
}

export default paymentSagas;
